<template>
  <span class="red--text tex--darken-3" v-html="text"></span>
</template>

<script>
export default {
  name: "RedText",
  props: {
    text: {
      type: String,
      default: "",
    },
  },
};
</script>